export default __webpack_public_path__ + "static/media/comercialConditions.e0546e8e.png";